<template>
  <div>
    <!-- <GlobalTable
      :title="title + ' List'"
      :fields="fields"
      :items="items"
      :editButton="true"
      :redirectDetail="true"
      :isLoading="isLoading"
      @addForm="addForm"
      @editForm="editForm"
    ></GlobalTable> -->

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :visibilityShow="visibilityShow"
                :showNeed="showNeed"
                :exportNeed="exportNeed"
                :title="title"
                @addForm="addForm"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :localization="localization"
                    :selectionmode="''"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <CForm>
        <CRow>
          <CCol sm="3">
            <CInput
              label="Name"
              invalid-feedback="Name should be filled"
              required
              v-model="$v.deliveryForm.name.$model"
              :is-valid="!$v.deliveryForm.name.$invalid"
            />
          </CCol>
          <CCol sm="3">
            <CInput
              label="Alias"
              invalid-feedback="Alias should be filled"
              required
              v-model="$v.deliveryForm.alias.$model"
              :is-valid="!$v.deliveryForm.alias.$invalid"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="6">
            <CTextarea
              rows="4"
              label="Description"
              invalid-feedback="Description should be filled"
              required
              v-model="$v.deliveryForm.description.$model"
              :is-valid="!$v.deliveryForm.description.$invalid"
            />
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.deliveryForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

export default {
  name: "Delivery",
  components: { Loading, TableButton, JqxGrid },
  data() {
    return {
      title: "Delivery",

      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "name", type: "string" },
          { name: "alias", type: "string" },
          { name: "description", type: "string" },
          { name: "delivery_status_name", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,

      productList: [],
      issueList: [],
      userList: [],

      fields: [
        {
          datafield: "name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Name",
        },
        {
          datafield: "alias",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Alias",
        },
        {
          datafield: "description",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Description",
        },
        {
          datafield: "delivery_status_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Status",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
      ],
      items: null,
      deliveryForm: tableInterfaces.delivery,
      isLoading: false,
      addButton: false,
      isEdit: false,

      showNeed:false,
      exportNeed:false,

      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    deliveryForm: {
      name: { required },
      alias: { required },
      description: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getProductIssue();
    },
    getProductIssue: function () {
      this.isLoading = true;
      this.axios
        .get("console/master/delivery/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            //this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.deliveryForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.delivery) {
        tableInterfaces.delivery[i] = null;
      }
      this.deliveryForm = tableInterfaces.delivery;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Do you want to add this data ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios
          .post("console/master/delivery/add", this.deliveryForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
              this.$router.push({ path: path[2] + "/detail/" + response.data.id });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>